import { useEffect, useRef } from 'react';

import { isTrackedStep, trackStepViewed } from './reconsentEvents';
import { TrackingSource } from '../trackingSource';
import { ModalStep } from '../useBankSelectionFlow';

export const useTrackModalStep = (step: ModalStep, source: TrackingSource) => {
    const lastStep = useRef<ModalStep | null>(null);

    useEffect(() => {
        if (lastStep.current === step) return;

        lastStep.current = step;
        if (!isTrackedStep(step)) return;

        trackStepViewed({ step, source });
    }, [step, source]);
};
